// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed9add34","455":"6563da38","488":"25705746"}[chunkId] + ".chunk.js";
};